import React, { useCallback, useRef } from 'react'
import styles from './Notice.module.scss'
import { useTranslation } from 'react-i18next'
import { getCurrentLanguage } from '@/i18next'
import { employerProfileThunks } from '@features/employerProfile/model'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { actions } from '@/entity/notifications/actions'
import { setToLocalStorage } from '@/shared'
import { notificationsSelectors, userActions } from '@/entity'
import { LoadingBlocker } from '@/components/Loader'
import ArrowIcon from '@app/icons/arrowIcon/ArrowIcon'
import { Tooltip } from 'antd'
import { Unsign } from '@app/icons'

const Notice = ({ notify, employer }) => {
	const { t } = useTranslation()
	const history = useHistory()
	const dispatch = useDispatch()
	const lang = getCurrentLanguage()
	const optionsLang = lang === 'rus' ? 'nameRu' : 'nameKz'
	const refValue = useRef(null)
	const isLoading = useSelector(notificationsSelectors.isLoading)

	const handleCompanySelect = useCallback((item) => {
		setToLocalStorage('activeRole', employer ? 'ROLE_EMPLOYER' : 'ROLE_EMPLOYEE')
		dispatch(userActions.setActiveRole(employer ? 'ROLE_EMPLOYER' : 'ROLE_EMPLOYEE'))
		if (employer) {
			dispatch(employerProfileThunks.getCompanyForBin(item.bin))
		}
		if (window.document.body.clientWidth < 1001) {
			history.push(`/notifications/${item.externalId}`, { refValue: item })
		} else {
			dispatch(actions.toggleSuccess(true))
			history.push('/notifications', { refValue: item })
		}
	}, [])
	const blueArray = ['emaket_22', 'emaket_21', 'emaket_4', 'emaket_3', 'emaket_20']

	const handleShowAllNotifications = (role) => {
		setToLocalStorage('activeRole', role)
		dispatch(userActions.setActiveRole(role))
	}

	return (
		<div className={styles.contains}>
			{!isLoading ? (
				<div className={styles.wrapper}>
					<div className={styles.tooltipFlex}>
						<p>
							{t('unread_notifications')}
							{' (' + notify?.length + ')'}
						</p>
						{employer && (
							<Tooltip
								placement="right"
								title={t('hint_page_role')}
								color="white"
								overlayInnerStyle={{ color: '#5B6880', borderRadius: '8px' }}
							>
								<span className={styles.signature__icon__wrapper}>
									<Unsign fill="#17b67c" />
								</span>
							</Tooltip>
						)}
					</div>
					<div className={styles.notificationRow}>
						{notify?.length > 0 ? (
							<>
								{notify?.map((item) => (
									<div
										key={item.externalId}
										className={`${blueArray.includes(item.notifType.code) ? styles.harm : ''} ${
											styles.notificationCell
										}`}
										ref={refValue}
										onClick={() => handleCompanySelect(item)}
									>
										<div className={styles.notificationRowContent}>
											<span>
												{item?.eventDate?.substring(0, 10) || ''} {item?.eventDate?.substring(11, 16) || ''}
												<p>{item.notifType?.[optionsLang]}</p>
											</span>
											<ArrowIcon color="#A5AEBE" />
										</div>
									</div>
								))}
							</>
						) : null}
					</div>
					<Link
						to="/notifications"
						className={styles.showAllNotifications}
						onClick={() => handleShowAllNotifications(employer ? 'ROLE_EMPLOYER' : 'ROLE_EMPLOYEE')}
					>
						{t('show_all_notifications')}
					</Link>
				</div>
			) : (
				<LoadingBlocker />
			)}
		</div>
	)
}

export default Notice
